module.exports = __webpack_public_path__ + "static/img/success.7ae2b313.svg";